<template>
  <div>
  <p class="content">
    Enter the email address of others from your company who you wish to invite to use Truckl. You can always do this at a later time as well.
    <br/>
    If you need to send a large number of invitations, simply create a list of emails separated by a comma (,) and paste it in to any field on this screen.
  </p>
  <div class="list-wrapper">
    <invitation-list v-model="emailList"/>
  </div>
  </div>
</template>

<script>
import InvitationList from '@/components/InviteToCompany'
import InviteApi from '@/api-interface/invite'
import { mapState } from 'vuex'

export default {
  name: 'Registration-InviteUsers',

  data() {
    return {
      emailList: []
    }
  },

  created() {
    // because this step is optional... notify the parent that it's ready right away
    this.$emit('canBeSubmitted', true)
  },

  async activated() {
    // because this step is optional... notify the parent that it's ready right away
    this.$emit('canBeSubmitted', true)
  },

  computed: {
    ...mapState('company', ['currentCompanyInfo'])
  },

  components: {
    InvitationList
  },

  methods: {
    async register() {
      if (this.emailList.length === 0) {
        return
      }

      const cleanList = Array.from(new Set(this.emailList))

      try {
        await InviteApi.inviteToCompanyBulk({ companyKey: this.currentCompanyInfo.companyKey, emailList: cleanList })
      } catch (error) {
        console.error('Error sending company invite.', error)
      }
    }
  }
}
</script>

<style scoped>
.list-wrapper {
  max-height: 50vh;
  overflow: auto;
}
</style>
